export const prefix = 'router';

export const GO_TO_PAGE_AND_SCROLL = `${prefix}/GO_TO_PAGE_AND_SCROLL`;
export const goToPageAndScroll = (path, id, offset) => ({
  type: GO_TO_PAGE_AND_SCROLL,
  payload: { id, path, offset },
});
